import SelectAction from '../ui/select-action'
import selectStyle from '../const/select'
// import amoEventConst from '../const/amo-event'
// import bitrixEventConst from '../const/bitrix24-event'
// import optGetEvent from '../utils/opt_get_event'

const FormWebhook = ({
  pipeline,
  keyGet,
  optPipeline,
  callback,
  keyCallback,
}) => {
  return (
    <div className="create-bundle-form">
      <div className="create-bundle-form-crm">
        <SelectAction
          label={'Select a pipeline'}
          value={pipeline}
          callback={callback}
          style={selectStyle}
          opt={optPipeline}
        />
      </div>
      <div className="create-bundle-form-crm">
        <label className="flex-label">
          Set a unique key (optional)
          <span className="optional-label">
            The key does not contain spaces and can contain _ and -
          </span>
        </label>
        <span className="flex-prevlink">
          https://back.traderiq.net/api/v1/webhooks/event/
          <input
            type="text"
            className="modal-column-line-select-input"
            placeholder="example_key_123"
            onChange={keyCallback}
            value={keyGet || ''}
          />
        </span>
      </div>
    </div>
  )
}

export default FormWebhook
